import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Mount once at the App root. On every route change we POST a lightweight
 * `page_view` beacon to /api/activity/track — the backend silently drops
 * the request if the caller isn't authed.
 *
 * We debounce with a ref so React 18's double-mount in <StrictMode> can't
 * double-count a single navigation.
 */
export const useActivityTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname + (location.search || '');
    if (path === lastPath.current) return;
    lastPath.current = path;

    const token = localStorage.getItem('token');
    if (!token) return;   // anonymous: skip (backend drops it anyway)

    const controller = new AbortController();
    fetch(`${API_BASE}/api/activity/track`, {
      method: 'POST',
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        Authorization:  `Bearer ${token}`,
      },
      body: JSON.stringify({
        action:   'page_view',
        category: 'navigation',
        path,
        label:    document.title || undefined,
      }),
      keepalive: true,
    }).catch(() => { /* silent — beacon */ });

    return () => controller.abort();
  }, [location.pathname, location.search]);
};

export default useActivityTracker;
